import { styled, css } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement, cloneElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Li, Div, Ul } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import Downshift from 'downshift';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import InputAddon from '../InputAddon/InputAddon.js';
import Spinner from '../Spinner/Spinner.js';
import { S as SpinnerSize } from '../utils-fabc7ae7.js';

const _excluded = ["highlighted", "theme"];
const Suggestion = styled(Li).attrs(_ref => {
  let {
      highlighted,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    color: highlighted ? theme.palette.action.active : theme.palette.text.primary,
    bg: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.divider}`,
    p: `${theme.spacing.sm}px ${theme.spacing.md}px`,
    m: `0 ${theme.spacing.sm}px`
  }, props);
})`
  cursor: pointer;
  text-align: left;
`;

const SuggestionsContainer = styled(Div)`
  position: absolute;
  width: 100%;
  overflow: auto;
  max-height: ${props => props.maxContainerHeight || '210px'};
  top: 48px;
  border-top: none;
  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    font-weight: ${theme.typography.fontWeightRegular};
    line-height: ${theme.typography.lineHeightBase};
    color: ${theme.palette.text.primary};
    border: 1px solid ${theme.palette.grey[100]};
    box-shadow: ${theme.shadows[3]};
    background-color: ${theme.palette.common.white};
  `};
  clip-path: polygon(-50% 0, 150% 0, 150% 150%, -50% 150%);
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  z-index: 100;
`;

const MenuUl = styled(Ul)`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const AutoSuggest = ({
  label = 'Search',
  emptyPlaceholder = 'No items found',
  styles = {},
  suggestions,
  onSelectedValueChange,
  onStateChange,
  onInputValueChange,
  itemToString,
  inputValue,
  isInputDisabled,
  selectedItem,
  itemRenderer,
  defaultIsOpen,
  initialIsOpen,
  openOnFocus,
  isLoading,
  stateReducer,
  excludeSelected,
  selectedItems
}) => {
  const renderItems = (highlightedIndex, getItemProps) => {
    if (itemRenderer) {
      return suggestions.map((item, index) => /*#__PURE__*/cloneElement(itemRenderer(item, highlightedIndex === index), _objectSpread2({}, getItemProps({
        index,
        item,
        key: item.value
      }))));
    }
    return suggestions.map((item, index) => {
      const alreadySelected = !!(selectedItems !== null && selectedItems !== void 0 && selectedItems.find(selectedSuggestion => selectedSuggestion.value === item.value));
      if (selectedItems !== null && selectedItems !== void 0 && selectedItems.length && excludeSelected && alreadySelected) {
        return null;
      }
      return /*#__PURE__*/createElement(Suggestion, _extends({
        key: item.value
      }, getItemProps({
        index,
        item,
        key: item.value
      }), {
        highlighted: highlightedIndex === index
      }), item.label);
    });
  };
  return /*#__PURE__*/createElement(Downshift, {
    inputValue: inputValue,
    selectedItem: selectedItem,
    onChange: onSelectedValueChange,
    itemToString: itemToString,
    onInputValueChange: onInputValueChange,
    onStateChange: onStateChange,
    defaultIsOpen: defaultIsOpen,
    initialIsOpen: initialIsOpen,
    stateReducer: stateReducer
  }, ({
    getInputProps,
    getItemProps,
    getMenuProps,
    getRootProps,
    isOpen,
    highlightedIndex,
    openMenu
  }) => {
    return /*#__PURE__*/createElement(Div, _extends({
      position: "relative"
    }, getRootProps({
      refKey: 'elRef'
    }), styles.root), /*#__PURE__*/createElement(TextInput, _extends({}, getInputProps(), {
      startInputAddon: /*#__PURE__*/createElement(InputAddon, {
        position: "start",
        isPointerEventsDisabled: true
      }, /*#__PURE__*/createElement(Icon, {
        glyph: icons.SEARCH
      })),
      endInputAddon: isLoading ? /*#__PURE__*/createElement(InputAddon, {
        position: "end"
      }, /*#__PURE__*/createElement(Spinner, {
        size: SpinnerSize.xSmall
      })) : null,
      disabled: isInputDisabled,
      label: label,
      styles: {
        input: _objectSpread2({}, styles.input)
      },
      onFocus: () => openOnFocus && openMenu()
    })), isOpen ? /*#__PURE__*/createElement(SuggestionsContainer, _extends({
      testId: "suggestions-container"
    }, styles.suggestions), /*#__PURE__*/createElement(MenuUl, getMenuProps, renderItems(highlightedIndex, getItemProps), !suggestions.length && /*#__PURE__*/createElement(Suggestion, getItemProps({
      key: 1,
      item: null
    }), emptyPlaceholder))) : null);
  });
};
var AutoSuggest$1 = Object.assign(AutoSuggest, {
  Item: Suggestion
});

export default AutoSuggest$1;
